module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "audit"
    }
  }, [_c('headernav', {
    attrs: {
      "type": "audit"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e7296a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/audit/index.vue
// module id = 764
// module chunks = 6